<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      customClass="techfileHeader"
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import Steam from '@/components/forms/technicalFile/network/steam/forms/Steam';
import Pretreatment from '@/components/forms/technicalFile/network/steam/forms/Pretreatment';
import Condense from '@/components/forms/technicalFile/network/steam/forms/Condense';
import History from '@/components/forms/technicalFile/network/steam/forms/history';
import lockService from '@/utilities/lockService';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [Steam, Pretreatment, Condense],
            empty: {
                steamIdentification: {
                    steamPressure: {
                        value: null,
                        units: null,
                    },
                    fuelSource: null,
                    fuelSourceOther: null,
                    operation: {
                        value: null,
                        units: null,
                    },
                    boilerConfiguration: null,
                    steamUsed: null,
                    steamUsedOther: null,
                    steamProduction: {
                        value: null,
                        units: null,
                    },
                    timeUnit: null,
                    feedwaterPumpOperation: null,
                    markeup: null,
                    makeupSource: null,
                    makeupSourceOther: null,
                },
                pretreatment: {
                    filtration: null,
                    ionExchangeSofteners: null,
                    dealkalizers: null,
                    reverseOsmosis: null,
                    demineralizer: null,
                    edx: null,
                    deaerator: null,
                    hotwell: null,
                },
                condense: {
                    mettalurgyInCondensateSystem: null,
                    mettalurgyInCondensateSystemOther: null,
                },
            },
            data: {
                nodeInfo: null,
            },
            model: null,
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
            'hasPermission',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },
    async created() {
        this.loading = true;
        await this.getNodeInfo();
        if (!this.units) {
            await this.loadUnits({ siteId: this.site.id, lang: this.userLang });
        }
        this.model = this.data.nodeInfo ? this.data.nodeInfo : this.empty;
        if (this.model.history && this.model.history.length) {
            // insert in last position
            this.components.splice(this.components.length, 0, History);
        }
        this.tabs = this.tableHeaders();
        this.loading = false;
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleUnload);
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileNetworkSteam');
        }
    },
    methods: {
        ...mapActions({
            loadUnits: 'getUnits',
        }),
        async getNodeInfo() {
            const { data } = await this.$rq.getNodeInfo(this.site.id, this.node.ref);
            if (Object.keys(data).length) this.data.nodeInfo = data;
        },
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { ...this.model, readonly: this.readonly },
                name: this.$t(`technicalFile.network.steam.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileNetworkSteam');
            }
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
    },
};
</script>
